// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"e_TB","wrapperDark":"e_UB","wrapperLight":"e_VB"};